
<template>
  <div class="container overflow-hidden ">
    <div class="row gx-5">
      <div class="col-3">
        <div class=" border bg-light">
          <div class="col">
            <div class="divider">

            </div>
            <div class="md-2">
              <button type="button" class="btn btn-success mt-2 ml-0" @click="updateSubmit()">Salvar</button>
              <router-link :to="`/player/${this.vslId}/customizacao`" class="btn btn-outline-secondary  mt-2 ml-1">
                Voltar
              </router-link>
            </div>

          </div>
          <div class="divider">

          </div>
          <div class="">

            <h2>
              <feather-icon icon="SunriseIcon" size="25" stroke="Gold" class="mr-50" /> Progresso
              Inteligente
            </h2>
          </div>
          <div class="divider"></div>
          <div class="container ">
            <form @submit.prevent="updateSubmit()">

              <div class="divider"></div>
              <div class="row">
                <div class="md-1" id="altura_barra-progresso">
                  <span
                    class="ant-typography ant-typography-ellipsis ant-typography-single-line ant-typography-ellipsis-single-line colorText___Jqdck">Altura
                    da Barra
                  </span>
                  <input v-model="bar[0].bar_hight" type="range" class="form-range" id="customRange" value="0"
                    name="points" inline min="1" max="15">
                  {{ bar[0].bar_hight }}
                </div>
              </div>
              <div class="divider"></div>
              <div class="ant-col" id="cor_barra-progresso" style="flex: 1 1 auto; min-width: 0px;">
                <span
                  class="ant-typography ant-typography-ellipsis ant-typography-single-line ant-typography-ellipsis-single-line colorText___Jqdck">Cor
                  da Barra
                </span>
                <input class="tb float-end" v-model="bar[0].bar_cor" type='color' onchange="changeColor();">
              </div>
            </form>
          </div>

          <div class="divider"></div>
        </div>
      </div>
      <div class="col player">
        <video muted class="player_my_video viewer" :poster='dadosVideo.thumb.thumbStart' :src='dadosVideo.URL'
          type="video/mp4"></video>
        <div
        v-if="dadosVideo.autoPlayer.autoPlayerAtivo"
        class="iniciar center" :style="'background-color:' + dadosVideo.autoPlayer.bgColorAuto">
          <h2 class="m-4" :style="'color:' + dadosVideo.autoPlayer.textColorAuto" _msthash="1354873"
            _msttexthash="308412">{{ dadosVideo.autoPlayer.textBottom }}</h2>
          <div class="loader"><span class="stroke"></span><span class="stroke"></span><span class="stroke"></span><span
              class="stroke"></span><span class="stroke"></span><span class="stroke"></span><span
              class="stroke"></span><span class="stroke"></span><span class="stroke"></span><span
              class="stroke"></span><span class="stroke"></span><span class="stroke"></span>
          </div>
          <h2 class="mt-0" :style="'color:' + dadosVideo.autoPlayer.textColorAuto" _msthash="1354874"
            _msttexthash="413270">{{ dadosVideo.autoPlayer.textTop }}</h2>
        </div>
        <div class="playpause" @click="togglePlay();" :style="'background-color:' + getControls[0].controls_back_color"
        v-if="dadosVideo.autoPlayer.autoPlayerAtivo === 0"></div>
        <div class="playpausebg" :style="'background-image:url(' + dadosVideo.thumb.thumbPause + ');'" hidden>
        </div>
        <div class="playEndedbg" :style="'background-image:url(' + dadosVideo.thumb.thumbEnd + ');'" hidden>
        </div>
        <nav class="player_my_controls" id="navega">

          <div class="progress" :style="'height:' + bar[0].bar_hight + 'px;background-color:' + bar[0].bar_cor + 'px;'"
            v-if="getControls[0].controls_progress_bar === 1">
            <div class="progress_my_filled" :style="'background-color:' + bar[0].bar_cor + ';flex-basis: 10.9778%;'">
            </div>
          </div>
          <button class="player_my_button toggle" _msthash="1603160" _msttexthash="878514"
            v-show="getControls[0].controls_bt_small_player === 1">
            ▶
          </button>
          <button class="player_my_button button_retroceder " v-show="getControls[0].controls_retro_10s === 1"><svg
              xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path fill="none" d="M0 0h24v24H0V0z"></path>
              <path
                d="M11.99 5V1l-5 5 5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6h-2c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8zm-1.1 11h-.85v-3.26l-1.01.31v-.69l1.77-.63h.09V16zm4.28-1.76c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32.04-.29.04-.48v-.97z"
                fill="#FFF" class="color000000 svgShape"></path>
            </svg></button>
          <button class="player_my_button button_avancar" v-show="getControls[0].controls_avan_10s === 1"><svg
              xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path
                d="M18.92 13c-.5 0-.91.37-.98.86-.48 3.37-3.77 5.84-7.42 4.96-2.25-.54-3.91-2.27-4.39-4.53C5.32 10.42 8.27 7 12 7v2.79c0 .45.54.67.85.35l3.79-3.79c.2-.2.2-.51 0-.71l-3.79-3.79c-.31-.31-.85-.09-.85.36V5c-4.94 0-8.84 4.48-7.84 9.6.6 3.11 2.9 5.5 5.99 6.19 4.83 1.08 9.15-2.2 9.77-6.67.09-.59-.4-1.12-1-1.12zm-8.02 3v-4.27h-.09l-1.77.63v.69l1.01-.31V16zm3.42-4.22c-.18-.07-.37-.1-.59-.1s-.41.03-.59.1-.33.18-.45.33-.23.34-.29.57-.1.5-.1.82v.74c0 .32.04.6.11.82s.17.42.3.57.28.26.46.33.37.1.59.1.41-.03.59-.1.33-.18.45-.33.22-.34.29-.57.1-.5.1-.82v-.74c0-.32-.04-.6-.11-.82s-.17-.42-.3-.57-.29-.26-.46-.33zm.01 2.57c0 .19-.01.35-.04.48s-.06.24-.11.32-.11.14-.19.17-.16.05-.25.05-.18-.02-.25-.05-.14-.09-.19-.17-.09-.19-.12-.32-.04-.29-.04-.48v-.97c0-.19.01-.35.04-.48s.06-.23.12-.31.11-.14.19-.17.16-.05.25-.05.18.02.25.05.14.09.19.17.09.18.12.31.04.29.04.48v.97z"
                fill="#fff" class="color000000 svgShape"></path>
            </svg></button>
            <button class="player_my_button button_volume" v-show="getControls[0].controls_video_vol === 1">
                        <svg viewBox="0 0 24 24" width="20" height="20">
                            <path
                            fill="#fff" d="M12 3.984v4.219l-2.109-2.109zM4.266 3l16.734 16.734-1.266 1.266-2.063-2.063q-1.547 1.313-3.656 1.828v-2.063q1.172-0.328 2.25-1.172l-4.266-4.266v6.75l-5.016-5.016h-3.984v-6h4.734l-4.734-4.734zM18.984 12q0-2.391-1.383-4.219t-3.586-2.484v-2.063q3.047 0.656 5.016 3.117t1.969 5.648q0 2.203-1.031 4.172l-1.5-1.547q0.516-1.266 0.516-2.625zM16.5 12q0 0.422-0.047 0.609l-2.438-2.438v-2.203q1.031 0.516 1.758 1.688t0.727 2.344z"></path>
                        </svg>

                    </button>

                    <button class="player_my_button fullscreenbtn" v-show="getControls[0].controls_bt_screem === 1">
                        <svg viewBox="0 0 24 24" width="20" height="20">
                            <path fill="#fff"
                                d="M14.016 5.016h4.969v4.969h-1.969v-3h-3v-1.969zM17.016 17.016v-3h1.969v4.969h-4.969v-1.969h3zM5.016 9.984v-4.969h4.969v1.969h-3v3h-1.969zM6.984 14.016v3h3v1.969h-4.969v-4.969h1.969z">
                            </path>
                        </svg>
                    </button>
                    <button class="player_my_button PictureInPicture"
                        v-show="getControls[0].controls_picture_in_picture === 1">
                        <svg viewBox="0 0 24 24" width="20" height="20">
                            <path fill="#fff"
                                d="M21 19.031v-14.063h-18v14.063h18zM23.016 18.984q0 0.797-0.609 1.406t-1.406 0.609h-18q-0.797 0-1.406-0.609t-0.609-1.406v-14.016q0-0.797 0.609-1.383t1.406-0.586h18q0.797 0 1.406 0.586t0.609 1.383v14.016zM18.984 11.016v6h-7.969v-6h7.969z">
                            </path>
                        </svg>
                    </button>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>


import Detalhes from '../../EditarVideo/Detalhes.vue';
import { BarsService } from '@/services/Bar';
import { ControlsService } from '@/services/Controls';
export default {
  components: {
    Detalhes,

  },
  data: function () {
    return {
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND,
      vslId: this.$route.params.vslId,
      loading: false,
      bar: {
        bar_cor: '',
        bar_hight: '',
        id_vsl: '',
      },
      errorMessage: null,
      control: [],
      dadosVideo: [],

    }
  },
  created: async function () {
    try {
      this.loading = true;

      this.loading = false;
    }
    catch (error) {
      this.errorMessage = error;
      this.loading = false;

    }
  },
  created: async function () {
    try {
      this.loading = true;
      let bar = await BarsService.getBarsVSL_Id(this.vslId)
      this.bar = bar.data;
      let response = await ControlsService.getControlVSL_Id(this.vslId)
      console.log(this.vslId);
      this.control = response.data;
      this.loading = false;
    } catch (error) {
      this.errorMessage = error;
      this.loading = false;

    }
  },
  computed: {
    getControls() {
      console.log("oi")
      return this.control
    }
  },
  beforeMount() {
    this.jsonPersonalizado();

  },
  methods: {
    jsonPersonalizado() {

      const url = `${this.VUE_APP_HOST_API_BACKEND}/vslsInner/` + this.vslId;
      fetch(url)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log(data.status)
          if (data.status == "1") {
            this.dadosVideo = data.json[0];
          }

        });
    },
    updateSubmit() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/bar/` + this.vslId, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: '{"bar_cor":"' + this.bar[0].bar_cor +
          '","bar_hight":"' + this.bar[0].bar_hight +
          '","id_vsl":"' + this.vslId + '"}'
      })

        .then(response => {
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso'
          });

        })

        .catch(err => console.error(err));
    },
  }



}

</script>
<style scoped>
.tb {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin: 0px;
  border: none;
}

.player {
  max-width: 875px;
  /* //border: 4px solid rgba(0,0,0,.2);
 //box-shadow: 0 0 20px rgba(0,0,0,.2); */
  position: relative;
  font-size: 20;
  overflow: hidden;
}

.player {
  width: 100%;
}

.player:fullcreen {
  max-width: none;
  width: 100%;
}


.player:-webkit-full-screen {
  max-width: none;
  width: 100%;
}

.player:-ms-full-screen {
  max-width: none;
  width: 100%;
}

.player:-moz-full-screen {
  max-width: none;
  width: 100%;
}

.player_my_video {
  min-width: 102%;
    height: 500px;

}

.player_my_controls {
  display: flex;
  position: absolute;
  bottom: 0;
  width: 100%;
  transform: translateY(100%) translateY(-31%);
  transition: all .3s;
  flex-wrap: wrap;
  background: rgba(0, 0, 0, .2);
}

.progress_my_filled {
  width: 80%;
  /* //background: #ffc600; */

  flex: 0;
  flex-basis: 0%;
}

.player:hover .player_my_controls {
  transform: translateY(0);
}

.player_my_controls>* {
  flex: 1;
}

.progress {
  flex: 10;
  position: relative;
  display: flex;
  flex-basis: 100%;

  transition: height .3s;
  background: rgba(0, 0, 0, .25);
  cursor: pointer;
  /* ew-resize*/
}

.player_my_button {
  background: none;
  border: 0;
  line-height: 1;
  color: white;
  text-align: center;
  outline: 0;
  padding: 10px 15px 10px 15px;
  cursor: pointer;
  max-width: 50px;

}

.playerSlider {
  display: block;
  width: 10px;
  height: 30px;
}

input[type=range] {
  -webkit-appearance: none !important;
  background: transparent;
  width: 100%;
  margin: 0 5px;
}

input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 2px;
  cursor: pointer;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0 0 1px rgba(13, 13, 13, 0);
  background: rgba(255, 255, 255, .8);
  border-radius: 1.3px;
  border: 0.2px solid rgba(1, 1, 1, 0)
}

input[type=range]::-webkit-slider-thumb {
  height: 10px;
  width: 10px;
  border-radius: 50px;
  background: #fff;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -4px;
  box-shadow: 0 0 2px rgba(0, 0, 0, .2);
}

input[type=range]:focus {
  outline: none;

}

input[type=range]:focus::-webkit-slider-runnable-track {
  background: #ff0;

}

/* Mozila Linha do volume*/

input[type=range]::-moz-range-track {
  width: 100%;
  height: 0.1px;
  cursor: pointer;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0 0 1px rgba(13, 13, 13, 0);
  background: #fff;
  border-radius: 1.3px;
  border: 0.2px solid rgba(1, 1, 1, 0)
}

/* Mozila Circulo do volume*/

input[type=range]::-moz-range-thumb {
  height: 10px;
  width: 10px;
  border-radius: 50px;
  border-color: none;
  background: #fff;
  cursor: pointer;
}

.fullscreenbtn {

margin-left: 75%;
border: 0;
line-height: 1;
color: white;
text-align: center;
align-content: stretch;
outline: 0;
cursor: pointer;
max-width: 4px;
}

.button_volume {

margin-left: -2%;
border: 0;
line-height: 1;
color: white;
text-align: center;
align-content: stretch;
outline: 0;
cursor: pointer;
max-width: 4px;
}

.PictureInPicture {
margin-left: -9%;
border: 0;
line-height: 1;
color: white;
text-align: center;
align-content: stretch;
outline: 0;
cursor: pointer;
max-width: 4px;
}


.playpause {

  border-radius: 50px;
  background-image: url(../img/play.svg);
  background-repeat: no-repeat;
  width: 100px;
  height: 100px;
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  margin: auto;
  background-size: contain;
  background-position: center;
  cursor: pointer;
  z-index: 10 !important;
}

.playpause {
  opacity: 1;
  transition: opacity 400ms;
}

.playpause[hidden] {
  opacity: 0;

}

.iniciar {
  border: 2px solid;
  border-style: none;
  border-radius: 15px 50px;
  display: block;
  width: 50%;
  height: 50%;
  position: absolute;
  flex-direction: column-reverse;
  display: flex;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  margin: auto;
  align-items: center;
  background-size: contain;
  background-position: center;

}

.video-banner {
  position: relative;
}

.video-banner .overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  z-index: 1;
}

.loader {
  height: 70px;
  width: 200px;
  display: flex;
  align-items: center;
}

.loader .stroke {
  display: block;
  position: relative;
  background: #f1f1f1;
  height: 50%;
  width: 15%;
  border-radius: 50px;
  margin: 0 5px;
  align-items: center;
  animation: animate 1.2s linear infinite;
}

/* .playImagem {
    width: 64px;
    height: 64px;
    cursor: pointer;
  } */


h2 {
  position: relative;
  align-self: center;
  font-family: Arial, Helvetica, sans-serif;
}

@keyframes animate {
  50% {
    height: 20%;
  }

  100% {
    height: 100%;
  }
}

.stroke:nth-child(1) {
  animation-delay: 0s;
}

.stroke:nth-child(2) {
  animation-delay: 0.3s;
}

.stroke:nth-child(3) {
  animation-delay: 0.6s;
}

.stroke:nth-child(4) {
  animation-delay: 0.9s;
}

.stroke:nth-child(5) {
  animation-delay: 0.6s;
}

.stroke:nth-child(6) {
  animation-delay: 0;
}

.stroke:nth-child(7) {
  animation-delay: 0.2s;
}

.stroke:nth-child(8) {
  animation-delay: 0.5s;
}

.stroke:nth-child(9) {
  animation-delay: 0.1s;
}

.stroke:nth-child(10) {
  animation-delay: 0s;
}

.stroke:nth-child(11) {
  animation-delay: 0.3s;
}

.stroke:nth-child(12) {
  animation-delay: 0.6s;
}

.stroke:nth-child(13) {
  animation-delay: 0.3s;
}

#context-menu {
  position: fixed;
  width: 170px;
  height: 20px;
  border: #000;
  background: rgba(40, 38, 38, 0.856);
  transform: scale(0);
  transform-origin: top left;
  padding: 8px 8px 8px 8px;
}

#context-menu.active {
  transform: scale(1);
  transition: transform 200ms ease-in-out;
}

#context-menu a {
  font-size: 15px;
  font-family: Arial, Helvetica, sans-serif;
  color: #eee;
  text-decoration: none;
}

#context-menu .item:hover {
  background: #555;
}

.playpausebg {

  background-repeat: no-repeat;
  width: 102%;
  height: 128%;
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  margin: auto;
  background-size: contain;
  background-position: center;
  cursor: pointer;
  z-index: 2 !important;
}

.playpausebg {
  opacity: 1;
  transition: opacity 400ms;
}

.playpausebg[hidden] {
  opacity: 0;

}

.playEndedbg {

  background-repeat: no-repeat;
  width: 102%;
  height: 128%;
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  margin: auto;
  background-size: contain;
  background-position: center;
  cursor: pointer;
  z-index: 2 !important;
}

.playEndedbg {
  opacity: 1;
  transition: opacity 400ms;
}

.playEndedbg[hidden] {
  opacity: 0;

}
</style>
